import React from "react";
import "./works.css";

const Wimg1 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654175/w1_eyl0rv.png";
const Wimg2 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654205/w2_lkg3iz.png";
const Wimg3 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654155/w3_uisljd.png";
const Wimg4 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654209/w4_od0whp.png";
const Wimg5 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654168/w5_xglqf8.png";
const Wimg6 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654204/w6_q653kg.png";
const Wimg7 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654150/w7_lisuf8.png";
const Wimg8 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654163/w8_ujn8v7.png";
const Wimg9 = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654205/w9_awbrfu.png";
const Wimg10=  "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654166/w10_nsglvx.png";
const Wimg11=  "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654181/w11_mywzya.png";
const Wimg12=  "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744654942/w12_rna81l.png";


const Works = () => {
  let url1 = "https://rock10.netlify.app/";
  let url2 = "https://cricketabid.netlify.app/";
  let url3 = "https://timer30.netlify.app/";
  let url4 = "https://g-calculator.netlify.app/";
  let url5 = "https://snakegamebd.netlify.app/";
  let url6 = "https://weatherbd.netlify.app/";
  let url7 = "https://copy-pastecolor.netlify.app/";
  let url8 = "https://0-9converter.netlify.app/";
  let url9 = "https://randomplayer.netlify.app/";
  let url10 = "https://rightpronunciation.netlify.app/";
  let url11 = "https://netgoods.netlify.app/";
  let url12 = "https://10quiz.netlify.app/";

  //see more
  let Repositories = "https://github.com/Abidhasan7-IT?tab=repositories";


  return (
    <section id="works">
      <h2 className="workstittle">My Works</h2>
      <span className="worksdec">
        Here are some of the projects I have worked on. You can find more
        information on them here:
      </span>

      <div className="works-details">
        <a href={url1} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg1} alt="projectimg" className="works-img" />
        </a>

        <a href={url2} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg2} alt="projectimg" className="works-img" />
        </a>

        <a href={url3} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg3} alt="projectimg" className="works-img" />
        </a>

        <a href={url4} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg4} alt="projectimg" className="works-img" />
        </a>

        <a href={url5} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg5} alt="projectimg" className="works-img" />
        </a>
        
        <a href={url6} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg6} alt="projectimg" className="works-img" />
        </a>

        <a href={url7} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg7} alt="projectimg" className="works-img" />
        </a>

        <a href={url8} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg8} alt="projectimg" className="works-img" />
        </a>

        <a href={url9} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg9} alt="projectimg" className="works-img" />
        </a>

        <a href={url10} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000">
          <img src={Wimg10} alt="projectimg" className="works-img" />
        </a>

        <a href={url11} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Wimg11} alt="projectimg" className="works-img" />
        </a>

        <a href={url12} target="_blank" rel="noreferrer" className="img-link" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000">
          <img src={Wimg12} alt="projectimg" className="works-img" />
        </a>
        
      </div>
      <a className="workbtn" href={Repositories} target="_blank" rel="noreferrer" >See More!</a>

    </section>
  );
};

export default Works;
